import React from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ErrorIcon from '@mui/icons-material/Error';

const useStyles = makeStyles(() => ({
  errorIcon: {
    marginLeft: '-3px',
    marginRight: '6px',
    marginBottom: '-6px'
  }
}));

const ServiceError = (): JSX.Element | null => {
  const classes = useStyles();

  return (
    <Box marginTop="1rem" marginBottom="2rem">
      <Typography color="error">
        <ErrorIcon color="inherit" aria-label="Form submission failed" className={classes.errorIcon} />
        <b>Form submission failed due to a system error. Please try again.</b>
      </Typography>
    </Box>
  );
};

export default ServiceError;
